import { DataObjectField } from "../../../../to-be-removed/LocalData/General/DataObjectField/DataObjectField";
import { DataObjectType } from "../../../../to-be-removed/LocalData/General/DataObjects/DataObjectHelper";
import { DataObjectHelpers } from "../../../../to-be-removed/LocalData/General/DataObjects/DataObjectHelpers";
import { IncomeData } from "../../../../to-be-removed/LocalData/Property/Income/IncomeData";
import { Utilities } from "../../../../utils/utilities";
import { ContractEndDateLabel } from "../../ContractEndDateLabel/ContractEndDateLabel";
import { DataTableDataCellValue, DataTableDataJSXElement, DataTableRawStringElement, isDataTableV2Element } from "../DataTable";

export class FirebaseDataTableHelper {
  static async convertElementToExportableData(
    element: DataTableDataCellValue | Promise<DataTableDataCellValue>,
    rawData: boolean
  ): Promise<string | number | Date> {
    if (element instanceof Promise) {
      element = await element;
    }
    if (typeof element === "string") {
      return element;
    } else if (typeof element === "number") {
      return element;
    } else if (element === undefined) {
      return "";
    } else if (element instanceof Date) {
      return element;
    } else if (isDataTableV2Element(element)) {
      if (element.loader) {
        await element.loader();
      }
      return this.convertElementToExportableData(element.cellValue(), rawData);
    } else if ((element as DataTableRawStringElement)?.displayString !== undefined && (element as DataTableRawStringElement)?.rawData !== undefined) {
      if (rawData) {
        return (element as DataTableRawStringElement).rawData;
      } else {
        return (element as DataTableRawStringElement).displayString;
      }
    } else if ((element as DataTableDataJSXElement) && (element as DataTableDataJSXElement).rawString) {
      return (element as DataTableDataJSXElement).rawString ?? "";
    } else {
      if (element.rawData === undefined || element.rawData === null) return "";
      return "" + element.rawData;
    }
  }

  static convertDataObjectFieldToDataTableElement<T extends DataObjectType>(field: DataObjectField<any, T>, data: T): DataTableDataCellValue {
    const value = field.dataGetter(data);
    if (value instanceof Date) {
      const stringValue = Utilities.formatDate(value, "local");
      if (field.key === "contractEndDate") {
        return { element: <ContractEndDateLabel date={value} />, rawString: stringValue, rawData: value };
      }
      return { element: <>{stringValue}</>, rawString: stringValue, rawData: value };
    } else if (value !== null && value !== undefined) {
      if (typeof value === "number") {
        return { displayString: field.getStringRepresentation(value), rawData: value } as DataTableRawStringElement;
      }
      if ((field as any) === DataObjectHelpers.unit.incomeData) {
        return {
          displayString: field.getStringRepresentation(value, false),
          rawData: value instanceof IncomeData ? value.sumOfIncomes(12) : 0,
        } as DataTableRawStringElement;
      }
      return field.getStringRepresentation(value);
    } else {
      return "";
    }
  }
}
